import { FaGithub } from "react-icons/fa";
import { SiLeetcode, SiHackerrank } from "react-icons/si";

export const Footer = () => {
    return (
        <footer className="text-white py-6 mt-10">
            <div className="container mx-auto text-center">
                <div className="flex flex-col md:flex-row justify-center md:justify-between items-center">
                    <p className="mb-4 md:mb-0">
                        &copy; {new Date().getFullYear()} Rahul P Prabhu. All rights reserved.
                    </p>
                    <div className="flex flex-row justify-end space-x-4">
                        <a
                            href="https://github.com/RahulPPrabhu"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 hover:text-blue-700"
                            aria-label="GitHub Profile"
                        >
                            <FaGithub size={30} aria-label="Github" role="img" />
                        </a>
                        <a
                            href="https://leetcode.com/u/pirate_king04/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-orange-500 hover:text-orange-700"
                            aria-label="LeetCode Profile"
                        >
                            <SiLeetcode size={30} aria-label="LeetCode" role="img" />
                        </a>
                        <a
                            href="https://www.hackerrank.com/profile/rahulpprabhu"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-green-500 hover:text-green-700"
                            aria-label="Hackerrank Profile"
                        >
                            <SiHackerrank size={30} aria-label="Hackerrank" role="img" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};
